module.exports = __webpack_public_path__ + "static/media/employeeIcon.7b9a6323.svg";